/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LandingOffersSlider.vue?vue&type=template&id=094918eb"
import script from "./LandingOffersSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingOffersSlider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LandingOffersSlider.vue?vue&type=style&index=0&id=094918eb&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports